import React from "react";
import { useTheme } from "../../contexts/ThemeContext";

const LoadingSpinner = ({
  size = "large",
  showLogo = false,
  fullScreen = false,
  message = "Yükleniyor...",
}) => {
  const { isDark } = useTheme();

  // Enterprise-standard sizes
  const dimensions = {
    small: "w-5 h-5 border-2",
    medium: "w-8 h-8 border-3",
    large: "w-12 h-12 border-4",
  };

  const spinnerClass = `
    ${dimensions[size]}
    rounded-full
    animate-spin
    border-gray-200 dark:border-zinc-800
    border-t-blue-600 dark:border-t-blue-500
  `;

  if (fullScreen) {
    return (
      <div
        className={`
        fixed inset-0 z-50 flex flex-col items-center justify-center
        ${isDark ? "bg-[#09090b]" : "bg-white"}
        transition-opacity duration-300
      `}
      >
         {showLogo && (
          <div className="mb-10 relative flex flex-col items-center">
            {/* Background Glow */}
            <div className="absolute inset-0 bg-blue-500/10 blur-3xl rounded-full scale-150"></div>
            
            <div className={`relative w-24 h-24 rounded-2xl flex items-center justify-center 
              ${isDark ? "bg-zinc-900/50 border-zinc-800" : "bg-gray-50 border-gray-200"} 
              border-2 shadow-2xl backdrop-blur-sm overflow-hidden animate-pulse`}
            >
              <img 
                src={isDark ? "/app_logo_dark.png" : "/athleticslogo.png"} 
                alt="The Athletics Logo" 
                className="w-16 h-16 object-contain"
              />
            </div>
            {/* Brand Name */}
            <h1 className={`mt-4 text-xl font-black tracking-tighter uppercase transition-colors duration-300 ${
              isDark ? "text-white" : "text-zinc-900"
            }`}>
              The Athletics
            </h1>
          </div>
        )}

        <div className={spinnerClass} />

        {message && (
          <p
            className={`mt-4 text-sm font-medium ${
              isDark ? "text-zinc-400" : "text-gray-500"
            }`}
          >
            {message}
          </p>
        )}
      </div>
    );
  }

  return (
    <div className="flex items-center justify-center p-4">
      <div className={spinnerClass} />
    </div>
  );
};

export default LoadingSpinner;
